import React from 'react';
import Button from '../Button';
import './styles.css';

/**
 * 錯誤信息組件
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.message - 錯誤信息
 * @param {Function} props.onRetry - 重試回調
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 錯誤信息組件
 */
function ErrorMessage({ message, onRetry, className = '' }) {
    return (
        <div className={`error-message ${className}`}>
            <div className="error-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" fill="currentColor" />
                </svg>
            </div>
            <div className="error-content">
                <div className="error-text">{message}</div>
                {onRetry && (
                    <Button
                        variant="primary"
                        size="small"
                        onClick={onRetry}
                        className="error-retry-button"
                    >
                        重試
                    </Button>
                )}
            </div>
        </div>
    );
}

export default ErrorMessage; 